import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from 'reactstrap';
import { BASE_URL, API } from 'CONST';
import { get } from 'helpers/requests';
import { headerOperationTwoValues } from 'helpers/tables';
import Seccion from './ReporteConsolidado/seccion';

const ModalHistorialTecho = ({ isOpen, toggle, organizationId }) => {
  const [historialTecho, setHistorialTecho] = useState([]);

  const fetchHistorialTecho = () => {
    if (!organizationId) return;
    get(`${BASE_URL}${API.historialtecho}/por_organizacion/?organization_id=${organizationId}`)
      .then(response => {
        if (response && response.length > 0) {
          setHistorialTecho(response);
        } else {
          setHistorialTecho([]);
        }
      })
      .catch(error => {
        console.error('Error al obtener el historial de techo:', error);
        setHistorialTecho([]);
      });
  };

  useEffect(() => {
    if (isOpen) {
      fetchHistorialTecho();
    }
  }, [isOpen]);

  const handleToggleDetails = (index) => {
    setHistorialTecho(prev => {
      const newData = [...prev];
      newData[index].expanded = !newData[index].expanded;
      return newData;
    });
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString('es-CL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

  return (
    <Modal
      isOpen={isOpen}
      style={{ maxWidth: "1000px", width: "70%" }}
      toggle={toggle}
      type="modal-warning warning-container"
    >
      <ModalHeader toggle={toggle} style={{ paddingBottom: "20px", paddingTop: "40px" }}>
        Historial de Techo Vigente
      </ModalHeader>

      <ModalBody style={{ paddingTop: "0px" }}>
        {(() => {
          if (historialTecho.length === 0) {
            return <p>No se encontraron datos.</p>;
          }

          return (
            <ul className="list-group">
              {historialTecho.map((item, index) => {
                const isExpanded = item.expanded;

                return (
                  <div key={index}>
                    <Button
                      className="list-group-item d-flex justify-content-between align-items-center"
                      style={{
                        cursor: 'pointer',
                        backgroundColor: '#f8f9fa',
                        color: '#343a40',
                        border: '1px solid #dee2e6',
                        borderRadius: '0.25rem',
                        marginBottom: '0.5rem',
                        width: "100%",
                      }}
                      onClick={() => handleToggleDetails(index)}
                    >
                      <FontAwesomeIcon
                        icon={isExpanded ? faMinus : faPlus}
                        className="svg-inline--fa fa-w-14 table-link"
                        style={{ marginRight: '10px' }}
                      />

                      <div className="d-flex justify-content-between w-100">
                        <div className="w-50 d-flex">
                          {headerOperationTwoValues('Techo Vigente (UF)', item.techo_vigente ?? '-', 'left')}
                        </div>

                        <div className="w-50 d-flex justify-content-end">
                          {headerOperationTwoValues('Fecha de Cambio', formatDate(item.fecha_cambio), 'right')}
                        </div>
                      </div>
                    </Button>

                    {isExpanded && (
                      <div className="details" style={{ paddingLeft: '15px', paddingTop: '10px' }}>
                        <Seccion
                          sectionData={[{
                            title: 'Detalles del Cambio',
                            type: 'v_headers',
                            headers: {
                              comentarios: { name: 'Comentarios' },
                              modificado_por: { name: 'Modificado por' },
                            },
                            data: {
                              comentarios: item.comentarios || 'No hay comentarios',
                              modificado_por: item.modificado_por || 'No disponible',
                            },
                          }]}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </ul>
          );
        })()}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cerrar</Button>
      </ModalFooter>
    </Modal>
  );
};

ModalHistorialTecho.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  organizationId: PropTypes.number.isRequired,
};

export default ModalHistorialTecho;
